/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filter_ExpandInputs */

const vi_common_filter_expand = /** @type {(inputs: Common_Filter_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở rộng bộ lọc`)
};

/**

* @param {Common_Filter_ExpandInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_filter_expand = /** @type {((inputs?: Common_Filter_ExpandInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_ExpandInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_filter_expand(inputs)
});